@if (loading) {
  <div class="overlay">
    <div class="overlay-content">
      <div class="backdrop">
        <img class="loading-icon" src="../../../assets/images/templates/2134/logo-loading.svg">
        <div class="loading-text">{{ animatedText }}</div>
      </div>
    </div>
  </div>
}